<template>
  <div class="install-guide">
    <div v-if="!isMobile">
      <div>使用当前页面需要安装一个谷歌浏览器插件：</div>
      <div class="link">
        <a :href="url" target="_blank">{{ url }}</a>
      </div>
      <div>
        <a href="https://ikrong.com/r/DevPanelCrx" target="_blank">
          离线下载
        </a>
      </div>
      <div>
        <a href="https://ikrong.com/r/setcrx" target="_blank">离线安装教程</a>
      </div>
    </div>
    <div v-else>继续使用请安装 ish.app 等</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://chrome.google.com/webstore/detail/bbpdammdpjonjnemjigapmiddimgpchp',
      guide: 'https://ikrong.com/post/j8B4Qm',
      isMobile: window.navigator.userAgent.match(/mobile/gi) ? true : false,
    };
  },
  methods: {
    open() {
      window.open(this.isMobile ? this.guide : this.url, '_blank');
    },
    beforeClose() {
      this.open();
      return Promise.reject();
    },
  },
};
</script>

<style lang="scss" scoped>
.install-guide {
  padding: 20px;
  word-break: break-all;
  line-height: 2;
  color: #5d5d5d;
  .link {
    font-size: 14px;
  }
  a {
    color: #99ec73;
  }
}
</style>